module.exports = __webpack_public_path__ + "static/media/2023_Best_Fintech_Initiative.b4f11675.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2023_Best_Fintech_Initiative.webp
// module id = 356
// module chunks = 0